import React, { useEffect, useState, useMemo, useCallback } from 'react';
import axios from 'axios';
import { Select } from '@rmwc/select';
import '@rmwc/select/styles';
import Autosuggest from './Autosuggest';
import './ProfilePicker.css';
import { useFlexionStore } from './Stores';
import { getText } from './Helpers';

const Blacklist = [
  'S 60x60',
  'ESP 30/2 (40)',
  'ESP 30x40 (40)',
  'KLD 30x30',
  'KLW 40-30',
  'KLW 20-15',
  'KLW 20-30',
  'KLW 20-45',
  'KLW 20-90',
  'MultiLift 230x37',
  'MultiLift 260x48',
];

function ProfilePicker(props) {
  const ProfilesFetched = useFlexionStore((state) => state.ProfilesFetched);
  const setProfilesFetched = useFlexionStore((state) => state.setProfilesFetched);
  const SerieVal = useFlexionStore((state) => state.SerieVal);
  const setSerieVal = useFlexionStore((state) => state.setSerieVal);
  const Profiles = useFlexionStore((state) => state.Profiles);
  const setProfiles = useFlexionStore((state) => state.setProfiles);
  const setProfileDesc = useFlexionStore((state) => state.setProfileDesc);
  const Serie = useFlexionStore((state) => state.Serie);
  const setSerie = useFlexionStore((state) => state.setSerie);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const [text, settext] = useState(getText(Sprache));
  const [Description, setDescription] = useState([]);

  function convertOptiontoGerman(Option) {
    if (Option === 'Units') return 'Lineareinheiten';
    if (Option === 'Tubes') return 'Rohre';
    return Option;
  }

  const AllDescriptions = useMemo(() => {
    const rohreDescription = [];
    const EcoDescription = [];
    const Konstruktionsprofile = [];
    const Schwerlastprofile = [];
    const Sichtprofile = [];
    const Rahmenprofile = [];
    const Sonderprofile = [];
    const SProfile = [];
    const EcoProfile = [];
    const Andere = [];
    const MoveTec = [];
    const AndereEinheiten = [];
    const PlaceTec = [];
    const dummysDescription = [];

    function sortFunctionName(a, b) {
      const nameA = a.value.toUpperCase(); // ignore upper and lowercase
      const nameB = b.value.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    }

    function groupEinheiten(desc) {
      if (
        desc.match('^RK LightUnit') ||
        desc.match('^E\\d') ||
        desc.match('^E II') ||
        desc.match('^RE') ||
        desc.match('^EP') ||
        desc.match('^PLM') ||
        desc.match('^PLS') ||
        desc.match('Compact') ||
        desc.match('RK DuoLine S 120x80') ||
        desc.match('^EV ')
      ) {
        MoveTec.push({ value: desc, label: desc });
      } else if (
        desc.match('Mono') ||
        desc.match('DuoLine Z') ||
        desc.match('Multi') ||
        desc.match('ZST') ||
        desc.match('MT')
      ) {
        PlaceTec.push({ value: desc, label: desc });
      } else {
        AndereEinheiten.push({ value: desc, label: desc });
      }
    }

    function groupProfiles(desc) {
      if (Blacklist.includes(desc)) return;
      if (
        desc.match('^15') ||
        desc.match('.*[^0-9]20x.*') ||
        desc.match('FR 20') ||
        desc.match('^\\dx')
      ) {
        Sonderprofile.push({ value: desc, label: desc });
      } else if (
        desc.match('^FG') ||
        desc.match('^F-G') ||
        desc.match('^F\\dG') ||
        desc.match('^F-\\dG') ||
        desc.match('^W') ||
        desc.match('^FR') ||
        desc.match('^F-R') ||
        desc.match('^G-') ||
        desc.match('^4G-') ||
        desc.match('^SP-')
      ) {
        Sichtprofile.push({ value: desc, label: desc });
      } else if (desc.match('^KL') || desc.match('^STP') || desc.match('^ESP')) {
        Rahmenprofile.push({ value: desc, label: desc });
      } else if (desc.match('^D')) {
        Schwerlastprofile.push({ value: desc, label: desc });
      } else if (desc.match('^F \\d{2}') || desc.match('^F-\\d{2}')) {
        Konstruktionsprofile.push({ value: desc, label: desc });
      } else if (desc.match('^S')) {
        SProfile.push({ value: desc, label: desc });
      } else {
        Andere.push({ value: desc, label: desc });
      }
    }

    Profiles.forEach((profile) => {
      if (profile.Series === 'BLOCAN®') groupProfiles(profile.Description);
      else if (profile.Series === 'Lineareinheiten') groupEinheiten(profile.Description);
      else if (profile.Series === 'Eco')
        EcoDescription.push({ value: profile.Description, label: profile.Description });
      else if (profile.Series === 'Rohre')
        rohreDescription.push({ value: profile.Description, label: profile.Description });
      else if (profile.Series === 'Dummy')
        dummysDescription.push({ value: profile.Description, label: profile.Description });
    });

    MoveTec.sort(sortFunctionName);
    PlaceTec.sort(sortFunctionName);
    AndereEinheiten.sort(sortFunctionName);

    const blocanDescription = [
      {
        label: text.ProfilePicker.Struct,
        options: Konstruktionsprofile,
      },
      {
        label: text.ProfilePicker.Visible,
        options: Sichtprofile,
      },
      {
        label: text.ProfilePicker.Frame,
        options: Rahmenprofile,
      },
      {
        label: text.ProfilePicker.Special,
        options: Sonderprofile,
      },
      {
        label: text.ProfilePicker.Heavy,
        options: Schwerlastprofile,
      },
      {
        label: text.ProfilePicker.Sprof,
        options: SProfile,
      },
      {
        label: text.ProfilePicker.Eco,
        options: EcoProfile,
      },
      {
        label: text.ProfilePicker.Other,
        options: Andere,
      },
    ];
    const linearDescription = [
      {
        label: 'Move-Tec',
        options: MoveTec,
      },
      {
        label: 'Place-Tec',
        options: PlaceTec,
      },
      {
        label: text.ProfilePicker.Other,
        options: AndereEinheiten,
      },
    ];
    return {
      blocanDescription,
      EcoDescription,
      linearDescription,
      rohreDescription,
      dummysDescription,
    };
  }, [
    Profiles,
    text.ProfilePicker.Eco,
    text.ProfilePicker.Frame,
    text.ProfilePicker.Heavy,
    text.ProfilePicker.Other,
    text.ProfilePicker.Special,
    text.ProfilePicker.Sprof,
    text.ProfilePicker.Struct,
    text.ProfilePicker.Visible,
  ]);

  const selectDescription = useCallback(
    (desc) => {
      if (desc === 'BLOCAN®') {
        return AllDescriptions.blocanDescription;
      } else if (desc === 'Eco') {
        return AllDescriptions.EcoDescription;
      } else if (desc === 'Lineareinheiten') {
        return AllDescriptions.linearDescription;
      } else if (desc === 'Rohre') {
        return AllDescriptions.rohreDescription;
      } else if (desc === 'Dummy') {
        return AllDescriptions.dummysDescription;
      }
    },
    [
      AllDescriptions.EcoDescription,
      AllDescriptions.blocanDescription,
      AllDescriptions.dummysDescription,
      AllDescriptions.linearDescription,
      AllDescriptions.rohreDescription,
    ]
  );

  /**
   * Nach dem Laden der Profile direkt Blocan auswählen
   */
  useEffect(() => {
    if (SerieVal === '' && ProfilesFetched) {
      setDescription(selectDescription('BLOCAN®'));
      setSerieVal('BLOCAN®');
    } // Description aktualisieren damit neue Dummys direkt nach dem erstellen angezeigt werden.
    else if (SerieVal === 'Dummy') {
      setDescription(selectDescription('Dummy'));
      setSerieVal('Dummy');
    }
  }, [ProfilesFetched, setSerieVal, SerieVal, selectDescription]);

  function handleDesc(e) {
    if (e !== undefined) {
      let option = e.target.value;
      if (option === SerieVal) return;
      if (Sprache !== 'de') {
        option = convertOptiontoGerman(e.target.value);
      }
      setProfileDesc('');
      setSerieVal(option);
      setDescription(selectDescription(option));
    } else {
      setDescription(selectDescription(SerieVal));
    }
  }

  function createOptionArray() {
    if (Sprache !== 'de' && Serie.length === 4) return ['BLOCAN®', 'Eco', 'Tubes', 'Units'];
    if (Sprache !== 'de' && Serie.length === 5)
      return ['BLOCAN®', 'Eco', 'Tubes', 'Units', 'Dummy'];
    return Serie;
  }

  function createSerieValMultiLang() {
    if (Sprache !== 'de') {
      if (SerieVal === 'Rohre') return 'Tubes';
      if (SerieVal === 'Lineareinheiten') return 'Units';
      if (SerieVal === 'Dummy') return 'Dummy';
      if (SerieVal === 'BLOCAN®') return 'BLOCAN®';
      if (SerieVal === 'Eco') return 'Eco';
    }
    return SerieVal;
  }

  useEffect(() => {
    if (!ProfilesFetched) {
      const seriesHelp = [];
      const data = [];
      axios.get('https://app.rk-rose-krieger.com/api/flexion/newprofile').then((response) => {
        response.data.forEach((i) => {
          if (!seriesHelp.includes(i.Series)) {
            seriesHelp.push(i.Series);
          }
          data.push(i);
        });
        setProfiles(data);
        setProfilesFetched(true);
        setSerie(seriesHelp);
      });
    }
  }, [ProfilesFetched, setProfiles, setProfilesFetched, setSerie]);

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  if (Description !== selectDescription(SerieVal)) {
    setDescription(selectDescription(SerieVal));
  }

  return (
    <div className='PickerDiv'>
      <Select
        enhanced
        label={text.ProfilePicker.Pick}
        options={createOptionArray()}
        onChange={handleDesc}
        value={createSerieValMultiLang()}
      />
      <Autosuggest val={Description} />
    </div>
  );
}

export default ProfilePicker;
